import Vue from "vue";
import VueRouter from "vue-router";
import { isLogin, openLogin } from "@/assets/js/utils";

Vue.use(VueRouter);

//主页框架
import Main from "@/views/main";
import Login from "@/views/auth/login"; //登录页面
import Register from "@/views/auth/register"; //注册页面

// //运单模块
// import DriverList from "@/views/waybill/driver-list"; //运单列表
// import DriverAdd from "@/views/waybill/driver-add"; //运单详情
// import WaybillList from "@/views/waybill/waybill-list"; //运单列表
// import WaybillDetail from "@/views/waybill/waybill-detail"; //运单详情
// import WaybillAdd from "@/views/waybill/waybill-add"; //运单添加
// import PlanList from "@/views/waybill/plan-list"; //计划单
// import planbillAdd from "@/views/waybill/planbill-add"; //添加计划单
// import PlanDetail from "@/views/waybill/plan-detail"; //计划单详情
// import AddressList from "@/views/waybill/address-list"; //地址库
// import AddressAdd from "@/views/waybill/address-add"; //添加地址
// import TransportList from "@/views/waybill/transport-list"; //运力库

// //财务模块
// import Pay from "@/views/finance/pay"; //支付和发票
// import PayRecord from "@/views/finance/pay-record"; //支付记录
// import InvoiceApply from "@/views/finance/invoice-apply"; //申请开票
// import Wallet from "@/views/finance/wallet"; //钱包流水
// import PayPwd from "@/views/finance/payPwd"; //设置支付密码

// //设置模块
// import AgentList from "@/views/set/agent-list"; //经纪人管理
// import AgentAdd from "@/views/set/agent-add"; //添加经纪人
// import MemberList from "@/views/set/member-list"; //成员管理
// import DepartmentAdd from "@/views/set/member-department-add"; //权限管理
// import PersonAdd from "@/views/set/member-person-add"; //权限管理
// import Enterprise from "@/views/set/enter"; //企业信息
// import SetPwd from "@/views/set/pwd"; //设置密码
// import News from "@/views/set/news-list"; //消息列表

//会员中心首页
// const MainModule = [
//   {
//     path: "/main",
//     component: Main,
//     name: "首页",
//     children: [],
//     meta: {
//       is_login: true
//     }
//   }
// ];

//用户登录注册模块
const AuthModule = [
  {
    path: "/auth/login",
    component: Login,
    name: "用户登录",
    meta: {
      is_login: false
    }
  },
  {
    path: "/auth/register",
    component: Register,
    name: "用户注册",
    meta: {
      is_login: false
    }
  }
];

// //运单模块
// const WaybillModule = [
//   {
//     path: "waybill/waybill-list",
//     component: WaybillList,
//     name: "运单列表"
//   },
//   {
//     path: "waybill/waybill-detail",
//     component: WaybillDetail,
//     name: "运单详情"
//   },
//   {
//     path: "waybill/waybill-add",
//     component: WaybillAdd,
//     name: "添加运单"
//   },
//   {
//     path: "waybill/plan-list",
//     component: PlanList,
//     name: "计划单"
//   },
//   {
//     path: "waybill/plan-detail",
//     component: PlanDetail,
//     name: "计划单详情"
//   },
//   {
//     path: "waybill/planbill-add",
//     component: planbillAdd,
//     name: "添加计划单"
//   },
//   {
//     path: "waybill/driver-list",
//     component: DriverList,
//     name: "司机列表"
//   },
//   {
//     path: "waybill/driver-add",
//     component: DriverAdd,
//     name: "添加司机"
//   },
//   {
//     path: "/waybill/address-list",
//     component: AddressList,
//     name: "地址库"
//   },
//   {
//     path: "/waybill/address-add",
//     component: AddressAdd,
//     name: "添加地址"
//   },
//   {
//     path: "waybill/transport-list",
//     component: TransportList,
//     name: "运力库"
//   }
// ];

// //财务模块
// const FinanceModule = [
//   {
//     path: "finance/pay",
//     component: Pay,
//     name: "支付和开票"
//   },
//   {
//     path: "finance/pay/pay-record",
//     component: PayRecord,
//     name: "支付记录"
//   },
//   {
//     path: "finance/pay/invoice-apply",
//     component: InvoiceApply,
//     name: "申请开票"
//   },
//   {
//     path: "finance/wallet",
//     component: Wallet,
//     name: "发票管理"
//   },
//   {
//     path: "finance/payPwd",
//     component: PayPwd,
//     name: "支付密码"
//   }
// ];

// //设置模块
// const SetModule = [
//   {
//     path: "set/agent",
//     component: AgentList,
//     name: "经纪人"
//   },
//   {
//     path: "set/agent/add",
//     component: AgentAdd,
//     name: "添加经纪人"
//   },
//   {
//     path: "set/member",
//     component: MemberList,
//     name: "成员管理"
//   },
//   {
//     path: "set/department-add",
//     component: DepartmentAdd,
//     name: "添加部门"
//   },
//   {
//     path: "set/person-add",
//     component: PersonAdd,
//     name: "添加人员"
//   },
//   {
//     path: "set/enter",
//     component: Enterprise,
//     name: "企业信息"
//   },
//   {
//     path: "set/pwd",
//     component: SetPwd,
//     name: "设置密码"
//   },
//   {
//     path: "news",
//     component: News,
//     name: "消息列表"
//   }
// ];

// let routes = [
//   {
//     path: "/",
//     component: Main,
//     children: []
//       .concat(WaybillModule)
//       .concat(FinanceModule)
//       .concat(SetModule)
//   }
// ]
//   .concat(MainModule)
//   .concat(AuthModule);

let routes = [
  {
    path: "/",
    name: "main",
    component: Main,
    meta: {
      is_login: true
    },
    children: []
  }
].concat(AuthModule);

const router = new VueRouter({
  mode: "history",
  routes: routes
});

//路由钩子函数;
// router.beforeEach((to, from, next) => {
//   if (to.path == "/") {
//     window.location.href = "/static/h5/default.html";
//     return;
//   }
//   let login = to.meta.is_login;
//   if (login == undefined || login) {
//     // 判断该路由是否需要登录权限
//     if (!isLogin()) {
//       // 获取是否登录
//       openLogin();
//       return next(false);
//     }
//   }
//   let allowBack = to.meta.allowBack;
//   if (allowBack == undefined || from.meta.allowBack == undefined) {
//     allowBack = true;
//   }
//   next(allowBack);
// });

let initRouter = false;
router.beforeEach((to, from, next) => {
  if (to.path == "/") {
    window.location.href = "/static/h5/default.html ";
    return;
  }

  if (!initRouter) {
    initRouter = true;
    routerGo(to, next);
    return false;
  }
  let login = to.meta.is_login;
  if (login == undefined || login) {
    // 判断该路由是否需要登录权限
    if (!isLogin()) {
      // 获取是否登录
      openLogin();
      return next(false);
    }
  }
  let allowBack = to.meta.allowBack;
  if (allowBack == undefined || from.meta.allowBack == undefined) {
    allowBack = true;
  }
  next(allowBack);
});

function routerGo (to, next) {
  Vue.prototype.api(170104, { style: "PC" }).then(res => {
    console.log(res.data);
    res.data.forEach(sub => {
      let title = sub.menu_name;
      //添加菜单路由
      if (sub.menu_url) {
        let bool = sub.is_login.name == "YES" ? true : false; //是否显示
        let modul = createModul(sub.menu_url, bool, title);
        routes[0].children.push(modul);
      }
      if (sub.options === null) {
        sub.options = [];
      }
      //添加功能路由
      if (sub.options.length > 0) {
        sub.options.forEach(option => {
          let modul = createModul(option.menu_url, false, option.menu_name);
          if (sub.is_login.name == "YES") {
            routes[0].children.push(modul);
          } else {
            routes.push(modul);
          }
        });
      }
    });
    console.log(routes);
    router.addRoutes(routes);
    next({ ...to, replace: true });
  });
}

function createModul (path, is_login, title) {
  return {
    path: path,
    component: r =>
      require.ensure([], () => r(require("@/views" + path)), "menu"),
    meta: {
      title: title,
      is_login: is_login
    }
  };
}

router.afterEach((to, form) => {
  setTimeout(() => {
    let navs = document.getElementsByClassName("el-tabs__item");
    for (var j = 0; j < navs.length; j++) {
      let key = window.location.href + "_nav";
      let nav = navs[j];
      nav.setAttribute("index", j);
      nav.onclick = function () {
        let index = this.getAttribute("index");
        _global_.cacheData.set(key, index);
      };
      let sel = _global_.cacheData.get(key);
      if (sel) {
        if (sel == j) {
          nav.setAttribute("aria-selected", "true");
          nav.setAttribute("tabindex", "0");
          nav.className = "el-tabs__item is-top is-active";
        } else {
          nav.removeAttribute("aria-selected");
          nav.setAttribute("tabindex", "-1");
          nav.className = "el-tabs__item is-top";
        }
      }
    }
  }, 300);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js